import React, { useState } from 'react'
import { inject, observer } from 'mobx-react'
import { CloseIcon } from './Icons'
import OverviewSection from './OverviewSection'
import IncomeSection from './IncomeSection'
import EconomicStrengthSection from './EconomicStrengthSection'
import ShareExportDropdown from '../../common/ShareExportDropdown'

// Generate colors for polygon points (static)
const polygonColors = [
  '#3B82F6', '#EF4444', '#10B981', '#F59E0B', '#8B5CF6',
  '#EC4899', '#06B6D4', '#84CC16', '#F97316', '#6366F1'
]

// Inner component that uses hooks - receives observables as props from outer observer
const IncomeDataSidebarInner = ({
  onClose,
  rightSidebarStore,
  loading,
  incomeAndPopData,
  incomeProgressData,
  showIncomePolygonData,
  showIndividualPolygonLines,
  polygonData,
  targetGroupId,
  selectedIncomePoint,
  areaIncome,
  totalPopulation,
  targetGroupName,
  singlePolygonData,
  singlePolygonId,
  aggSelector,
  incomeYears,
  incomeSelectedYear,
  latestYear,
  uiStore,
  onOpenPopulationDashboard
}) => {
  const [expandedChart, setExpandedChart] = useState(null)
  // Safe defaults
  const safeTotalPopulation = totalPopulation || 0
  const safeTargetGroupName = targetGroupName || 'Central'
  const safeYears = incomeYears || []
  // const safeSelectedYear = incomeSelectedYear || latestYear || (safeYears.length > 0 ? safeYears[safeYears.length - 1] : '2021')
  const safeSelectedYear = '2021'
  const safeIncomeAndPopData = incomeAndPopData || []
  const safeIncomeProgressData = incomeProgressData || []
  const safePolygonData = polygonData || []

  const highestPopulation = (safeTotalPopulation != null && safeTotalPopulation > 0)
    ? safeTotalPopulation
    : (safeIncomeAndPopData && safeIncomeAndPopData.length > 0
        ? Math.max(...safeIncomeAndPopData.map(item => item.population || 0))
        : 0)

  const hasIncomeData = Boolean(
    (singlePolygonData && singlePolygonData.stats) ||
    (safeIncomeAndPopData && safeIncomeAndPopData.length > 0) ||
    (safeIncomeProgressData && safeIncomeProgressData.length > 0) ||
    (safePolygonData && safePolygonData.length > 0) ||
    (rightSidebarStore && rightSidebarStore.populationData && rightSidebarStore.populationData.data && rightSidebarStore.populationData.data.length > 0)
  )
  const isNoDataError = Boolean(
    rightSidebarStore &&
    rightSidebarStore.error === 'No polygon data available'
  )

  const isAnyLoading = Boolean(loading || (uiStore && uiStore.processing))

  const isDataLoading = Boolean(
    isAnyLoading &&
    !rightSidebarStore.noData &&
    !hasIncomeData
  )

  const safeAreaIncomeValue = areaIncome || 0
  const isExpandedMode = expandedChart !== null

  return (
    <div className={`income-data-sidebar ${isExpandedMode ? 'income-data-sidebar--expanded' : ''}`}>
      <div className='income-data-sidebar__header'>
        <div className='income-data-sidebar__header-content' style={{ flex: 1, minWidth: 0, marginRight: isExpandedMode ? 0 : '12px' }}>
          <h2 className='income-data-sidebar__title'>Income</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '100%', marginTop: '4px' }}>
            <span className='income-data-sidebar__folder' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 30px)' }}>
              {/* {(singlePolygonData && (singlePolygonData.name || singlePolygonData.title)) || safeTargetGroupName} */}
              {safeTargetGroupName}
            </span>
            <ShareExportDropdown />
          </div>
        </div>
        {!isExpandedMode && (
          <button
            type='button'
            className='income-data-sidebar__close-btn'
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        )}
      </div>

      <div className={`income-data-sidebar__content ${isExpandedMode ? 'income-data-sidebar__content--expanded' : ''} ${(loading || (uiStore && uiStore.processing)) && hasIncomeData && !singlePolygonData && !rightSidebarStore.noData ? 'loading loading-dark' : ''}`}>
        {(showIncomePolygonData && !singlePolygonData) && (
          <button
            type='button'
            className='income-data-sidebar__back-to-summary'
            onClick={() => {
              // if (showIncomePolygonData && !singlePolygonData && rightSidebarStore && rightSidebarStore.targetGroupId && rightSidebarStore.targetGroupName) {
              //   rightSidebarStore.fetchPopulationDataForTargetGroup(
              //     rightSidebarStore.targetGroupId,
              //     rightSidebarStore.targetGroupName
              //   )
              //   return
              // }
              // rightSidebarStore.clearSinglePolygon()
              if (rightSidebarStore) {
                rightSidebarStore.selectedLine = null
                rightSidebarStore.selectedLinePopulationDatas = null
                rightSidebarStore.showIndividualPolygonLines = false
                rightSidebarStore.showPolygonLines = false
                rightSidebarStore.showIncomePolygonData = false
                rightSidebarStore.restoreSummaryWorldpopAvailability()
              }
            }}
          >
            <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M3.66602 8.0013H12.666' stroke='#0A0A0A' stroke-linecap='round' stroke-linejoin='round' />
              <path d='M7.33394 12.0013C7.33394 12.0013 3.33399 9.05534 3.33398 8.00127C3.33398 6.9472 7.334 4.0013 7.334 4.0013' stroke='#0A0A0A' stroke-linecap='round' stroke-linejoin='round' />
            </svg>
            Back to Summary
          </button>
        )}
        {!rightSidebarStore && (
          <div className='income-data-sidebar__loading'>
            Loading...
          </div>
        )}
        {isDataLoading && (
          <div className='income-data-sidebar__loading income-data-sidebar__loading--spinner'>
            <div className='spinner' />
          </div>
        )}
        {rightSidebarStore && rightSidebarStore.error && !isNoDataError && (
          <div className='income-data-sidebar__error'>
            Error: {rightSidebarStore.error}
          </div>
        )}
        {!isAnyLoading && rightSidebarStore && (isNoDataError || !rightSidebarStore.error) && (rightSidebarStore.noData || !hasIncomeData) && (
          <div className='income-data-sidebar__loading'>
            {isNoDataError ? rightSidebarStore.error : 'No data available'}
          </div>
        )}
        {hasIncomeData && !rightSidebarStore.noData && !isNoDataError && (
          <>
            {!isExpandedMode && (
              <OverviewSection
                safeAreaIncomeValue={safeAreaIncomeValue}
                highestPopulation={highestPopulation}
                safeTotalPopulation={safeTotalPopulation}
                singlePolygonData={singlePolygonData}
                aggSelector={aggSelector}
                rightSidebarStore={rightSidebarStore}
                onOpenPopulationDashboard={onOpenPopulationDashboard}
              />
            )}
            {(!isExpandedMode || expandedChart === 'income') && (
              <IncomeSection
                showIncomePolygonData={showIncomePolygonData}
                showIndividualPolygonLines={showIndividualPolygonLines}
                safeIncomeProgressData={safeIncomeProgressData}
                polygonColors={polygonColors}
                safeAreaIncomeValue={safeAreaIncomeValue}
                safeTotalPopulation={safeTotalPopulation}
                aggSelector={aggSelector}
                incomeSelectedYear={incomeSelectedYear}
                polygonData={polygonData}
                singlePolygonData={singlePolygonData}
                rightSidebarStore={rightSidebarStore}
                uiStore={uiStore}
                isExpanded={expandedChart === 'income'}
                onToggleExpand={() => setExpandedChart(expandedChart === 'income' ? null : 'income')}
              />
            )}
            {(!isExpandedMode || expandedChart === 'economic') && (
              <EconomicStrengthSection
                safeSelectedYear={safeSelectedYear}
                safeYears={safeYears}
                safeIncomeAndPopData={safeIncomeAndPopData}
                showIncomePolygonData={showIncomePolygonData}
                polygonData={safePolygonData}
                polygonColors={polygonColors}
                selectedIncomePoint={selectedIncomePoint}
                safeTargetGroupName={safeTargetGroupName}
                singlePolygonData={singlePolygonData}
                singlePolygonId={singlePolygonId}
                rightSidebarStore={rightSidebarStore}
                uiStore={uiStore}
                isExpanded={expandedChart === 'economic'}
                onToggleExpand={() => setExpandedChart(expandedChart === 'economic' ? null : 'economic')}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

// Outer component wrapped with observer - accesses observables and passes as props
const IncomeDataSidebar = observer(({ onClose, rightSidebarStore, uiStore, onOpenPopulationDashboard }) => {
  // Access observables here so observer can track them
  const loading = rightSidebarStore.loading
  const incomeAndPopData = rightSidebarStore.incomeAndPopDataForChart
  const incomeProgressData = rightSidebarStore.incomeProgressData
  const showIncomePolygonData = rightSidebarStore.showIncomePolygonData
  const showIndividualPolygonLines = rightSidebarStore.showIndividualPolygonLines
  const polygonData = rightSidebarStore.polygonData || []
  const targetGroupId = rightSidebarStore.targetGroupId
  const selectedIncomePoint = rightSidebarStore.selectedIncomePoint
  const totalPopulation = rightSidebarStore.totalPopulation
  const targetGroupName = rightSidebarStore.targetGroupName
  const singlePolygonData = rightSidebarStore.singlePolygonData
  const singlePolygonId = rightSidebarStore.singlePolygonId
  const aggSelector = rightSidebarStore.aggSelector
  const incomeYears = rightSidebarStore.incomeYears
  const incomeSelectedYear = rightSidebarStore.incomeSelectedYear
  const latestYear = rightSidebarStore.latestYear

  // Calculate area income from populationData or singlePolygonData
  const getAreaIncome = () => {
    if (rightSidebarStore && rightSidebarStore.medianHouseholdIncome !== undefined) {
      return rightSidebarStore.medianHouseholdIncome
    }

    // If single polygon is selected, use its income data
    if (singlePolygonData && singlePolygonData.stats && singlePolygonData.stats.hh_income) {
      const availableIncomeData = singlePolygonData.stats.hh_income.filter(x => x.value !== null && x.value > 0)
      const income = singlePolygonData.stats.hh_income.filter(x => x.year === 2021)
      return income.length > 0 ? income[0].value : availableIncomeData.length > 0 ? availableIncomeData[0].value : 0
    }

    if (!rightSidebarStore.populationData || !rightSidebarStore.populationData.data || rightSidebarStore.populationData.data.length === 0) {
      return 0
    }
    const availableData = rightSidebarStore.populationData.data.filter(x => x.total_income > 0)
    const latestData = rightSidebarStore.populationData.data.filter(x => x.year === 2021)

    if (aggSelector === 'dissolved') {
      const dissolvedData = rightSidebarStore.populationData.dissolved_data
        ? rightSidebarStore.populationData.dissolved_data[rightSidebarStore.populationData.dissolved_data.length - 1]
        : null
      return dissolvedData ? (dissolvedData.total_income || 0) : 0
    } else if (aggSelector === 'avg') {
      return latestData.length > 0 ? latestData[0].average_income : availableData.length > 0 ? availableData[0].average_income : 0
    } else {
      const income = latestData.length > 0 ? latestData[0].total_income : availableData.length > 0 ? availableData[0].total_income : 0
      return income
    }
  }

  const areaIncome = getAreaIncome()

  return (
    <IncomeDataSidebarInner
      onClose={onClose}
      rightSidebarStore={rightSidebarStore}
      loading={loading}
      incomeAndPopData={incomeAndPopData}
      incomeProgressData={incomeProgressData}
      showIncomePolygonData={showIncomePolygonData}
      showIndividualPolygonLines={showIndividualPolygonLines}
      polygonData={polygonData}
      targetGroupId={targetGroupId}
      selectedIncomePoint={selectedIncomePoint}
      areaIncome={areaIncome}
      totalPopulation={totalPopulation}
      targetGroupName={targetGroupName}
      singlePolygonData={singlePolygonData}
      singlePolygonId={singlePolygonId}
      aggSelector={aggSelector}
      incomeYears={incomeYears}
      incomeSelectedYear={incomeSelectedYear}
      latestYear={latestYear}
      uiStore={uiStore}
      onOpenPopulationDashboard={onOpenPopulationDashboard}
    />
  )
})

export default inject('rightSidebarStore', 'uiStore')(IncomeDataSidebar)
